export class PackagingSystemPaginationFields {
  public static readonly Id = "Id";
  public static readonly DirectoryId = "DirectoryId";
  public static readonly BrandName = "BrandName";
  public static readonly ProductName = "ProductName";
  public static readonly ArticleNumber = "ArticleNumber";
  public static readonly Tag = "Tag";
  public static readonly Supplier = "Supplier";
}

export class PackagingUnitPaginationFields {
  public static readonly Id = "Id";
  public static readonly DirectoryId = "DirectoryId";
  public static readonly BrandName = "BrandName";
  public static readonly ProductName = "ProductName";
  public static readonly ArticleNumber = "ArticleNumber";
  public static readonly Tag = "Tag";
  public static readonly PackagingType = "PackagingType";
  public static readonly Supplier = "Supplier";
}

export class PackagingComponentPaginationFields {
  public static readonly Id = "Id";
  public static readonly DirectoryId = "DirectoryId";
  public static readonly ArticleName = "ArticleName";
  public static readonly ArticleNumber = "ArticleNumber";
  public static readonly Tag = "Tag";
  public static readonly Manufacturer = "Manufacturer";
  public static readonly PackagingComponentCategory = "PackagingComponentCategory";
  public static readonly PackagingComponentSubtype = "PackagingComponentSubtype";
}

export class MultiMaterialPaginationFields {
  public static readonly Id = "Id";
  public static readonly DirectoryId = "DirectoryId";
  public static readonly ArticleName = "ArticleName";
  public static readonly ArticleNumber = "ArticleNumber";
  public static readonly Tag = "Tag";
  public static readonly Manufacturer = "ManufacturerName";
}
